import StepPedagogicalApproachComponent from './stepPedagogicalApproachComponent';
import PedagogicalApproachAreaComponent from './pages/pedagogicalApproachAreaComponent';
import ParametersComponent from './pages/parameters/parametersComponent';
import PedagogicalService from './../../../manageSkills/services/pedagogicalService';
import RulerService from './services/rulerService';

const StepPedagogicalApproachModule = angular.module('app.stepPedagogicalApproach', [])
    .component('stepPedagogicalApproach', StepPedagogicalApproachComponent)
    .component('pedagogicalApproachArea', PedagogicalApproachAreaComponent)
    .component('parameters', ParametersComponent)
    .service('RulerService', RulerService)
    .service('PedagogicalService', PedagogicalService);

export default StepPedagogicalApproachModule;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/index.js